import { skipToken, useQuery } from '@tanstack/react-query'
import { fetchEstablishment, fetchEstablishments } from '../queries/establishments.queries'

export const useEstablishments = () =>
  useQuery({
    queryFn: () => fetchEstablishments(),
    queryKey: ['establishments'],
  })

export const useEstablishment = (id?: number) =>
  useQuery({
    queryKey: ['establishment', id],
    queryFn: id ? () => fetchEstablishment(id) : skipToken,
  })
